import gql from 'graphql-tag'

export default gql`
  query getPaymentMethod {
    getPaymentMethod {
      success
      message
      created
      type
      customer
      billingDetails {
        email
        name
        address {
          city
          country
          line1
          line2
          postalCode
          state
        }
      }
      card {
        brand
        country
        displayBrand
        expMonth
        expYear
        funding
        last4
      }
    }
  }
`
